import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Typography,
  MenuItem,
  Select,
  FormControl,
  Stack,
  Divider,
  Autocomplete,
  TextField,
} from '@mui/material';
import { poppins300, poppins400, poppins500 } from 'theme/common.style';
import { postApiCall } from 'api/apiService';
import { GET_APPRAISAL_PREFILL } from 'constant/app.config';

export const Pendingwarning = () => {
  return (
    <svg
      width="38"
      height="36"
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37.5797"
        height="36"
        rx="18"
        fill="#F39800"
        fill-opacity="0.1"
      />
      <path
        d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
        fill="#F39800"
      />
    </svg>
  );
};

const AddAppraisalDialog = ({
  open,
  onClose,
  onSelect,
  responseData,
  addresses,
}) => {
  const [property, setProperty] = useState('');

  const storedFullName = localStorage.getItem('primaryOwnerName');

  const handleSelect = (event) => {
    const selected = event.target.value;
    if (selected === 'add_new') {
      handleAddNewAddress();
    } else {
      setProperty(selected);
      onSelect(selected);
    }
  };

  const handleAddNewAddress = () => {
    // You can open another dialog or redirect to a form
    alert('Redirecting to Add New Appraisal Property form...');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent sx={{ p: 4 }}>
        <Typography
          sx={{ mb: 1, ...poppins400, color: '#666666', fontSize: '14px' }}
        >
          Add Appraisal - {storedFullName}
        </Typography>

        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
          {/* <WarningAmberIcon color="warning" /> */}
          <Pendingwarning />
          <Typography
            sx={{ ...poppins500, color: '#000000', fontSize: '24px' }}
          >
            Select Property
          </Typography>
        </Stack>

        {/* using select */}
        {/* <Box>
          <Typography sx={{ mb: 1,...poppins400,color:"#666666",fontSize:"16px" }}>
            Select Property
          </Typography>

          <FormControl fullWidth>
            <Select
              value={property}
              onChange={handleSelect}
              displayEmpty
              sx={{
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: 400,
                color: '#333',
                '& .MuiSelect-select': {
                  py: 1.5,
                  px: 2,
                },
              }}  
            >
              <MenuItem value="" disabled 
              sx={{
                ...poppins300,
                fontSize:"16px",
                color:"#666666"
              }}
              >
                -- Select a Property --
              </MenuItem>
              {addresses.map((addr, idx) => (
                <MenuItem key={idx} value={addr}
                
                sx={{
                  ...poppins300,
                  fontSize:"16px",
                  color:"#666666"
                }}
                >
                  {addr}
                </MenuItem>
              ))}

              <Divider sx={{ my: 1 }} />
              <MenuItem
                value="add_new"
                sx={{
                  color: 'primary.main',
                  fontWeight: 500,
                  pl: 2,
                }}
              >
                + Add New Appraisal Property
              </MenuItem>
            </Select>
          </FormControl>
        </Box> */}

        {/* using autocomplete */}
        <Box>
          <Typography
            sx={{
              mb: 1,
              ...poppins400,
              color: '#666666',
              fontSize: '16px',
            }}
          >
            Select Property
          </Typography>

          <Autocomplete
            fullWidth
            value={property}
            onChange={(event, newValue) => {
              if (newValue === 'add_new') {
                onClose(); // this will be triggered on selecting "Add New"
              } else {
                handleSelect({ target: { value: newValue } });
              }
            }}
            options={addresses}
            filterOptions={(options, state) => {
              const filtered = options.filter((opt) => {
                if (opt === 'add_new') return false; // don't filter this here
                return opt?.addressDetails?.details?.address
                  ?.toLowerCase()
                  .includes(state?.inputValue?.toLowerCase());
              });

              return [...filtered, 'add_new']; // always append 'add_new'
            }}
            getOptionLabel={(option) =>
              option === 'add_new'
                ? '+ Add New Appraisal Property'
                : option?.addressDetails?.details?.address || ''
            }
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="-- Select a Property --"
                variant="outlined"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    ...poppins300,
                    fontSize: '16px',
                    color: '#666666',
                    px: 2,
                    py: 1.5,
                    '& fieldset': { borderColor: '#0093FF' },
                    '&:hover fieldset': { borderColor: '#0093FF' },
                    '&.Mui-focused fieldset': { borderColor: '#0093FF' },
                  },
                  '& input': {
                    padding: '10px 0',
                  },
                }}
              />
            )}
            renderOption={(props, option) =>
              option === 'add_new' ? (
                <Box
                  component="li"
                  {...props}
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#4CA4D6',
                    pl: 2,
                    cursor: 'pointer',
                  }}
                >
                  + Add New Appraisal Property
                </Box>
              ) : (
                <Box
                  component="li"
                  {...props}
                  sx={{
                    ...poppins300,
                    fontSize: '16px',
                    color: '#666666',
                  }}
                >
                  {/* {option} */}
                  {option?.addressDetails?.details?.address}
                </Box>
              )
            }
            isOptionEqualToValue={(option, value) => option === value}
          />
        </Box>
        <Box
          display={'flex'}
          justifyContent={'flex-end'}
          alignItems={'flex-end'}
          mt={4}
        >
          <Typography
            value="add_new"
            sx={{
              ...poppins400,
              fontSize: '16px',
              color: '#4CA4D6',
              pl: 2,
              cursor: 'pointer',
            }}
            onClick={onClose}
          >
            + Add New Appraisal Property
          </Typography>
        </Box>
        <Stack
          direction="row"
          justifyContent="flex-end"
          spacing={2}
          sx={{ mt: 4 }}
        >
          <Button
            variant="outlined"
            sx={{
              ...poppins400,
              fontSize: '14px',
              bgcolor: '#fff',
              borderRadius: '8px',
              borderColor: '#1123471A',
              textTransform: 'none',
              width: 100,
              color: '#666666',
              '&:hover': {
                bgcolor: '#fff',
                borderColor: '#1123471A',
              },
            }}
            onClick={onClose}
          >
            Back
          </Button>
          <Button
            variant="contained"
            sx={{
              ...poppins400,
              fontSize: '14px',
              bgcolor: '#4CA4D6',
              borderRadius: '8px',
              textTransform: 'none',
              width: 100,
              '&:hover': {
                bgcolor: '#3293d0',
              },
            }}
          >
            Next
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default AddAppraisalDialog;
